import SignIn from "@/views/agent2/SignIn.vue";

export const authRouter = [
    {
        path: "/login",
        name: "SignIn",
        component: SignIn,
        meta: {},
    },
]